<template>
  <div class="alert-derivation">
    <h4 class="is-uppercase title">Informar a Equipo</h4>
    <span class="description">
      El responsable del alumno será informado de manera automática. En caso de querer informar a
      alguien más, por favor, seleccionar.
    </span>

    <div class="derivations">
      <div class="derivation" v-for="(d, index) in items" :key="d.id">
        <div>
          <div>
            <div class="multiselect-container">
              <multiselect :options-list="users" v-model="d.chosenUser"></multiselect>
            </div>
            <button class="button" @click="removeDerivation(index)">
              <img class="icon icon-svg" src="@/static/svg/icono_basura.svg" alt="next" />
            </button>
          </div>
        </div>
        <textarea
          placeholder="Comentario personal para usuario a informar (máx 140 caracteres)."
          v-model="d.message"
        ></textarea>
      </div>

      <div class="actions">
        <button class="button is-primary is-outlined add-derivation" @click="addDerivation">
          +
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag"
import { uniqueId } from "lodash"
import Multiselect from "@/components/shared/multiselect/Multiselect.vue"

export default {
  name: "DerivationList",
  props: {
    initialDerivations: {
      type: Number,
      default: 1
    },
    derivations: {
      type: Array,
      required: true
    },
    userList: {
      type: Array,
      required: false,
      default: null
    }
  },
  data() {
    return {
      users: [],
      items: [],
      setup: false
    }
  },
  apollo: {
    users: {
      query: gql`
        query Users {
          users {
            id
            name
            email
            isStaff
          }
        }
      `,
      skip() {
        return this.userList !== null
      },
      update(data) {
        return data.users
      }
    }
  },
  // When the componente mounts, create some derivation items
  mounted() {
    if (this.userList !== null) {
      this.users = this.userList
    }
    if (this.initialDerivations > 0 && !this.setup) {
      for (let i = 0; i < this.initialDerivations; i++) {
        console.log("adding derivation")
        this.addDerivation()
      }
      this.setup = true
      this.$emit("update:derivations", this.items)
    }
  },
  watch: {
    userList(newList) {
      console.log("updating user list")
      this.users = newList
      this.items.forEach(derivation => {
        derivation.chosenUser =
          newList.find(user => {
            if (user === null || derivation === null || (derivation && !derivation.chosenUser)) {
              return false
            }

            return user.id === derivation.chosenUser.id
          }) || null
      })
    }
  },
  methods: {
    addDerivation() {
      this.items.push({
        id: uniqueId("derivation_"),
        chosenUser: null,
        message: ""
      })
      this.$emit("update:derivations", this.items)
    },

    removeDerivation(derivationIndex) {
      this.items.splice(derivationIndex, 1)
      this.$emit("update:derivations", this.items)
    }
  },
  components: {
    Multiselect
  }
}
</script>

<style scoped>
select {
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  height: 35px;
  width: 350px;
  background-color: #f2f2f2;
  color: #7a7a7a;
}

textarea {
  box-sizing: border-box;
  resize: vertical !important;
  display: block;
  width: 100%;
  min-height: 66px;
  background-color: #f2f2f2;
  border-color: #e0e0e0;
  border-radius: 5px;
  padding: 10px 10px;
}

.title {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: var(--color-neutral-90);
}

.description {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--color-neutral-90);
}

.alert-derivation {
  margin-bottom: 35px;
}

.derivation {
  margin: 10px 0;
}

.derivation .button {
  height: 35px;
  width: 37px;
}

.derivation textarea {
  margin-top: 10px;
}

.add-derivation {
  margin: 0px;
  border-width: 2px;
}

.actions .add {
  padding: 0 35px;
}

.actions .cancel {
  padding: 0 15px;
}

.multiselect-container {
  width: auto;
  max-width: 500px;
  min-width: 450px;
  margin-right: 8px;
  display: inline-block;
}
</style>
